import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { compose } from 'redux';

import store from '../../store';
import { messagesRestHooks } from '../../store/Messages/MessagesSlice';
import { messagesUsersRestHooks } from '../../store/Messages/MessagesUsersSlice';

import SendMessageForm from './components/SendMessageForm';

const SendMessageContainer = () => {
  const {
    loadMessages,
    loadResetMessages,
    messages: { loadingStatus, items: messages },
  } = messagesRestHooks.use();

  const {
    createMessagesUser: sendMessage,
    messagesUser: { errors },
  } = messagesUsersRestHooks.use();

  useEffect(() => {
    loadMessages();
    return () => {
      loadResetMessages();
    };
  }, []);

  return (
    <SendMessageForm
      messages={messages}
      loadingStatus={loadingStatus}
      onSendMessage={sendMessage}
      apiErrors={errors}
    />
  );
};

const addStore = (ProxyComponent) => (props) =>
  (
    <Provider store={store}>
      <ProxyComponent {...props} />
    </Provider>
  );

export default compose(addStore)(SendMessageContainer);
